import api from '../../../api/clinique/_prestation'

// Types de facturation des analyses, examens, actes et chirurgies : repli si la liste n'est pas disponible (15/10/2026)
const TYPES_FACTURATION_DEFAUT = [{ value: 'normal' }, { value: 'urgence' }]

const state = () => ({
    tarif_group_prestation: {},
    tarif_liste_medicaments: {},
    types_facturation_prestation: [],
})

// getters
const getters = {
    tarif_group_prestation: (state) => {
        return state.tarif_group_prestation
    },

    tarif_liste_medicaments: (state) => {
        return state.tarif_liste_medicaments
    },

    types_facturation_prestation: (state) => {
        return (state.types_facturation_prestation.length > 0) ? state.types_facturation_prestation : TYPES_FACTURATION_DEFAUT
    },
}

// mutations
const mutations = {
    SET_TARIF_GROUP_PRESTATION(state, exam) {
        state.tarif_group_prestation = exam
    },

    SET_TARIF_LISTE_MEDICAMENTS(state, exam) {
        state.tarif_liste_medicaments = exam
    },

    SET_TYPES_FACTURATION_PRESTATION(state, types) {
        state.types_facturation_prestation = types
    },
}

// actions
const actions = {
    getTarifByGroupPrestation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifByGroupPrestation(data).then(
                (response) => {
                    commit("SET_TARIF_GROUP_PRESTATION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    /**
     * Types de facturation (normal, urgence) : chargés une seule fois ; en cas d'échec ou de liste vide, le getter
     * renvoie normal / urgence
     */
    getTypesFacturationPrestation({ commit, state }) {
        if (state.types_facturation_prestation.length > 0) {
            return Promise.resolve(state.types_facturation_prestation)
        }
        return api.getTypesFacturationPrestation().then((response) => {
            const types = (Array.isArray(response)) ? response.filter(type => type.value === 'normal' || type.value === 'urgence') : []
            commit("SET_TYPES_FACTURATION_PRESTATION", types)
            return (types.length > 0) ? types : TYPES_FACTURATION_DEFAUT
        }).catch(() => TYPES_FACTURATION_DEFAUT)
    },

    saveBulletinAnalyse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveBulletinAnalyse(data).then(
                response => {
                    dispatch
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveDemandeExamen({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveDemandeExamen(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTarifListePrestation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifListePrestation(data).then(
                (response) => {
                    commit("SET_TARIF_LISTE_MEDICAMENTS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    setPaidDemandeAnalyse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.setPaidDemandeAnalyse(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setPaidDemandeExamen({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.setPaidDemandeExamen(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setPaidPharmacieArticle({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.setPaidPharmacieArticle(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setPaidProtocoleConstitution({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.setPaidProtocoleConstitution(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}